import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";
import ModalColumn from "@coworker/apprestructured/src/task-management/components/ModalColumn/ModalColumn";
import styles from "./TitledTextWithBadges.module.css";
import { FixaBadge } from "@coworker/apprestructured/src/shared/wrappers/FixaBadge/FixaBadge";

type TitledTextWithBadgesProps = {
  title: string;
  text: string | undefined;
  badges: string[];
};

function TitledTextWithBadges({
  title,
  text,
  badges,
}: TitledTextWithBadgesProps) {
  return (
    <ModalColumn gap="small">
      <FixaText textStyle="Heading.S" tagName="h2">
        {title}
      </FixaText>
      {text === undefined ? (
        <FixaSkeleton height="24px" />
      ) : (
        <FixaText className={styles["text"]} textStyle="Body.L">
          {text}
        </FixaText>
      )}
      <div className={styles["badges"]}>
        {badges.map((badge, index) => (
          <FixaBadge
            key={`${badge}-${index}`}
            label={badge}
            colour="white"
            size="small"
          />
        ))}
      </div>
    </ModalColumn>
  );
}

export default TitledTextWithBadges;
